module.exports = __webpack_public_path__ + "static/media/bernie.461d3a72.png";